<template>
  <section id="solutions" class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-[#f0f2f5]">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
      <div class="text-center mb-10 sm:mb-12 md:mb-16">
        <h2
          class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-[#0b105d] mb-4"
          data-aos="fade-up"
        >
          {{ $t('solutions.title') }}
        </h2>
        <div
          class="w-16 sm:w-20 md:w-24 h-1 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] mx-auto"
          data-aos="fade-up"
          data-aos-delay="100"
        ></div>
      </div>

      <div class="space-y-12 sm:space-y-16">
        <div
          v-for="(solution, index) in solutions"
          :key="solution.titleKey"
          class="flex flex-col lg:flex-row items-center gap-6 sm:gap-8 md:gap-10 lg:gap-12"
          :class="{ 'lg:flex-row-reverse': index % 2 !== 0 }"
          data-aos="fade-up"
          :data-aos-delay="index * 100"
        >
          <div class="w-full lg:w-1/2">
            <div class="relative group">
              <div
                class="absolute -inset-1 bg-gradient-to-r from-[#fe6d0d] to-[#ffb47c] rounded-2xl sm:rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-500"
              ></div>
              <div
                class="relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 shadow-xl group-hover:shadow-2xl transition-shadow duration-300"
              >
                <component
                  :is="solution.icon"
                  class="h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 text-[#fe6d0d] mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300"
                />
                <h3 class="text-xl sm:text-2xl md:text-3xl font-bold text-[#0b105d] mb-3 sm:mb-4">
                  {{ $t(solution.titleKey) }}
                </h3>
                <p class="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed">
                  {{ $t(solution.descriptionKey) }}
                </p>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/2">
            <div
              class="relative h-64 sm:h-72 md:h-80 rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl group"
            >
              <div
                class="absolute inset-0 bg-gradient-to-br from-[#0b105d] to-[#fe6d0d] opacity-90 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
              <div class="absolute inset-0 flex items-center justify-center">
                <component
                  :is="solution.icon"
                  class="h-24 w-24 sm:h-28 sm:w-28 md:h-32 md:w-32 text-white opacity-10 group-hover:opacity-20 group-hover:scale-105 transition-all duration-300"
                />
              </div>
              <div
                class="relative z-10 h-full flex flex-col items-center justify-center p-6 sm:p-8 text-center text-white"
              >
                <div
                  class="text-4xl sm:text-5xl md:text-6xl font-black mb-3 sm:mb-4 opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                >
                  {{ index + 1 }}
                </div>
                <div
                  class="text-lg sm:text-xl font-light opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                >
                {{ $t('solutions.highlight') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { BrainCogIcon, TextSearchIcon, TrendingUpDownIcon } from 'lucide-vue-next'
import { ref } from 'vue'

const solutions = ref([
  {
    titleKey: 'solutions.interpretingData.title',
    descriptionKey: 'solutions.interpretingData.description',
    icon: TextSearchIcon,
  },
  {
    titleKey: 'solutions.modelTraining.title',
    descriptionKey: 'solutions.modelTraining.description',
    icon: BrainCogIcon,
  },
  {
    titleKey: 'solutions.dynamicAdaptation.title',
    descriptionKey: 'solutions.dynamicAdaptation.description',
    icon: TrendingUpDownIcon,
  },
])
</script>
